import React from 'react';
import { translate } from 'components/Translation';
import { HeadingMBold } from 'components/Typography/Typography';
import { makeStyles } from '@material-ui/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/tryAndBuy/tryAndBuyStyle';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import ActiveService from './subcomponents/ActiveService';

// @ts-ignore
const useStyles = makeStyles(styles);

const TryAndBuy = () => {
	const classes = useStyles();

	return (
		<>
			<BreadcrumbsItem to="/dashboard/try-and-buy">{translate('path.try.and.buy')}</BreadcrumbsItem>
			<GridContainer className={classes.gridWrapper}>
				<GridItem xs={12}>
					<div className={classes.headerWrapper}>
						<h1 className={classes.heading}>
							<HeadingMBold color="secondary-light" disableMargin asSpan>
								{translate('path.try.and.buy')}
							</HeadingMBold>
						</h1>
					</div>
				</GridItem>
				<GridItem>
					<ActiveService
						serviceName={translate('tryandbuy.fbb.serviceName')}
						servicePeriod={translate('tryandbuy.fbb.servicePeriod')}
					/>
				</GridItem>
			</GridContainer>
		</>
	);
};

export default TryAndBuy;
